<template>
  <div class="bg-surface-modal rounded-md p-16 text-center">
    <p v-if="perkType === 'Data'" class="heading-xs text-text-success">
      +{{ buybackStore.selectedEstimate?.TradeInMonthlyDataAmount }} GB surf/mån
    </p>
    <p v-if="perkType === 'CostReduction'" class="heading-xs text-text-success">
      +{{ buybackStore.selectedEstimate?.TradeInMonthlyValue }} kr/mån i rabatt
    </p>
    <p v-if="perkType === 'CostReduction'" class="heading-xxs pb-16">
      i {{ buybackStore.selectedEstimate?.DownPaymentTime }} månader,
      <span
        >värde {{ buybackStore.selectedEstimate?.TradeInTotalValue }} kr</span
      >
    </p>
    <p v-if="perkType === 'Data'" class="heading-xxs pb-16">i 24 månader</p>
    <AppButton
      :full-width="true"
      :disabled="buybackStore.data.valuateOnly"
      size="sm"
      @click="clickHandler"
    >
      Välj
    </AppButton>
  </div>
</template>

<script lang="ts" setup>
const hideDrawer = defineModel<boolean>();
const buybackStore = useBuybackStore();
const checkoutStore = useMyCheckoutStore();

interface Props {
  perkType: 'Data' | 'CostReduction' | 'Accessory';
}
const props = defineProps<Props>();

const { pushAddBuybackEvent } = useGoogleAnalyticsEvents();

const clickHandler = async () => {
  await buybackStore.addPerk(props.perkType);

  if (buybackStore.selectedBuybackProduct !== undefined) {
    pushAddBuybackEvent(
      buybackStore.selectedCondition,
      props.perkType,
      checkoutStore.trackingData.ecommerce,
      buybackStore.selectedBuybackName,
    );
  }

  hideDrawer.value = false;
};
</script>

<style></style>
